import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import { Box, Typography, Link } from '@mui/material'
import { useGetLastInvoiceLinkMutation } from '../redux/api/userApi'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PaymentPastDueDlg from './PaymentPastDueDlg'
import * as React from 'react'

const PaymentPastDue = ({ color = '', linkColor = null, flexDirection = 'row', alignItems = 'center', displayIcon = true }: any) => {
  const [getLastLinkInvoice, { isLoading, isSuccess, data }] = useGetLastInvoiceLinkMutation()
  const mode = useSelector((state: any) => state.modeState)
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => {
    setOpen(!open)
  }

  const handleClose = async () => {
    await getLastLinkInvoice({})
    setOpen(!open)
  }

  useEffect(() => {
    if (isSuccess) {
      window.open(data.url, '_blank')
    }
  }, [isSuccess])

  return (
    <Box
          color={color ?? 'primary'}
          sx={{
            display: 'flex',
            flexDirection: { flexDirection },
            alignItems: { alignItems }
          }}>
            { displayIcon
              ? <ReportProblemIcon sx={{
                height: '16px'
              }}/>
              : null
            }
            <PaymentPastDueDlg
              open={open}
              handleClose={handleOpen}
              handleMode={handleClose}
              cancelPlanReason={'123'}
              isWarning={true}
            />
            <Typography color={color ?? 'primary'} sx={{ mr: 1 }}>Payment Past Due</Typography>
            { !mode.isWp && !isLoading
              ? <Link color={linkColor ?? 'primary'}
                  sx={{
                    color: linkColor ?? 'primary',
                    fontSize: 14,
                    fontWeight: 400,
                    '&:hover': {
                      color: linkColor ?? 'primary'
                    }
                  }}
                  onClick={handleOpen}>
                  View Invoice
                </Link>
              : null
            }
        </Box>
  )
}

export default PaymentPastDue
